export default __webpack_public_path__ + "static/media/aws-da.bfcbd88c.png";